import React, { FunctionComponent } from "react";
import { PlanCompareAnalyticsSubsection } from "../../../app/contexts/Analytics/types";
import { ReminderIcon } from "../../../components";
import { useTranslate } from "../../../helpers";
import YearOverYearExploreOptionsButton from "./YearOverYearExploreOptionsButton";

const YearOverYearNextSteps: FunctionComponent = () => {
  const t = useTranslate();

  return (
    <div className="YearOverYear__nextSteps">
      <h2 className="ds-u-margin-bottom--4 ds-u-display--flex ds-u-align-items--center">
        <ReminderIcon className="YearOverYear__reminderIcon" />{" "}
        <span className="ds-u-margin-left--2">
          {t("yoy.next_steps.next_steps")}
        </span>
      </h2>
      <div className="ds-u-md-display--flex">
        <div className="YearOverYear__nextStepChoice">
          <h3 className="ds-u-margin--0 ds-u-margin-bottom--1">
            {t("yoy.next_steps.keep_plan")}
          </h3>
          <p className="ds-u-margin--0">
            {t("yoy.next_steps.keep_plan_do_nothing")}
          </p>
        </div>
        <div className="YearOverYear__nextStepChoice">
          <h3 className="ds-u-margin--0 ds-u-margin-bottom--1">
            {t("yoy.next_steps.other_options")}
          </h3>
          <p className="ds-u-margin--0">
            {t("yoy.next_steps.compare_other_options")}
          </p>
          <YearOverYearExploreOptionsButton
            subsection={PlanCompareAnalyticsSubsection.NEXT_STEPS}
          />
        </div>
      </div>
    </div>
  );
};

export default YearOverYearNextSteps;
